(function () {
  window.EHPriceSlider = {
    init: function () {
      var container = document.querySelector('[data-price-range]');
      if (!container) return;
      var maxInput = container.querySelector('[data-price-max]');
      var maxDisplay = container.querySelector('[data-price-max-display]');
      if (!maxInput) return;

      function updateDisplay() {
        if (maxDisplay) maxDisplay.textContent = '$' + parseInt(maxInput.value).toFixed(0);
      }

      maxInput.addEventListener('input', updateDisplay);
      maxInput.addEventListener('change', function () {
        var form = document.getElementById('FilterForm');
        if (!form) return;
        // requestSubmit fires the submit event (needed for AJAX intercept);
        // fall back to submit() on older browsers where it's unavailable
        if (form.requestSubmit) {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });

      updateDisplay();
    }
  };

  window.EHPriceSlider.init();
})();
